import { useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import NavBar from "../NavBar/navBar";
import { deleteExhibition, getExhibitions } from "./request";
import { useAuth } from "../context/AuthContext";
import { IMAGE_URL } from "../constants/Consts";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

const Exhibition = () => {
    const navigate = useNavigate();
    const [exhibitions, setExhibitions] = useState([]);
    const { authToken } = useAuth();
    const IMAGE_SHOW = `${IMAGE_URL}exhibitionImages`
    const [loading, setLoading] = useState(false);

    // Fetch Exhibitions
    const getExhibitionsList = useCallback(async () => {
        try {
            const response = await getExhibitions(authToken);
            if (response.Result) {
                setExhibitions(response.Exhibitions);
            } else {
                console.error("Failed to fetch exhibitions:", response.Msg);
            }
        } catch (error) {
            console.error("Error fetching exhibitions:", error);
        }
    }, [authToken]);

    // Fetch exhibitions on component mount
    useEffect(() => {
        getExhibitionsList();
    }, [authToken, getExhibitionsList]);


    const handleEditExhibition = (exhibitionId)=>{
        navigate('/exhibition/editExhibition', { state: { exhibitionId } });
    }
    const handleDelete = async(id)=>{
        setLoading(true);
        try {
            const response = await deleteExhibition(authToken,id);
            if(response.Result){
                alert('Exhibition Deleted')
                getExhibitionsList();
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }
    return (
        <>
            <NavBar />
            <div className="px-8 py-5">
                <div className="flex justify-between items-center mb-4">
                    <h1 style={{ fontWeight: 700, fontSize: '2rem', color: '#222' }}>Exhibitions</h1>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/exhibition/createExhibition')}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={20} color="inherit" /> : 'Add Exhibition'}
                    </Button>
                </div>

                {/* Exhibition Table */}
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-200">
                            <th className="border px-4 py-2">Cover</th>
                                <th className="border px-4 py-2">Year</th>
                                <th className="border px-4 py-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {exhibitions.length > 0 ? (
                                exhibitions.map((exhibition, index) => (
                                    <tr key={exhibition._id} className="hover:bg-gray-100">
                                        <td className="border flex justify-center px-4 py-2 text-center items-center">
                                            {exhibition.image ? (
                                                <img src={`${IMAGE_SHOW}/${exhibition.image}`} alt="Cover" className="w-30 h-20 object-cover rounded" />
                                            ) : (
                                                "No Image"
                                            )}
                                        </td>
                                        <td className="border px-4 py-2 text-center">{exhibition.year}</td>
                                        <td className="border px-4 py-2 text-center">
                                            <Stack direction="row" spacing={1} justifyContent="center">
                                                <Button variant="contained" color="success" onClick={()=>handleEditExhibition(exhibition.id)} disabled={loading}>View</Button>
                                                <Button variant="contained" color="error" onClick={()=>handleDelete(exhibition.id)} disabled={loading}>{loading ? <CircularProgress size={20} color="inherit" /> : 'Delete'}</Button>
                                            </Stack>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center py-4">No exhibitions found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default Exhibition;